"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.helpOverlay = void 0;
const basic_1 = require("../basic");
const font_faces_1 = require("./font-faces");
exports.helpOverlay = (0, basic_1.applyBase)({
    container: {
        bg: 'bgLightBlue',
        pt: ['30px', '50px'],
        pb: [4, '60px'],
        px: ['60px', 4],
        flexDirection: ['column', 'row'],
        alignItems: ['center', 'stretch'],
        width: '100%',
        flex: ['1', 'auto'],
    },
    wrapper: {
        position: 'relative',
        pt: [4, '20px'],
        mb: [3, 2],
        '&:not(:last-child)': {
            mr: [0, '30px'],
        },
    },
    schedule: {
        mt: [1, 3],
        '> p': Object.assign(Object.assign({}, font_faces_1.FONT_SIZE.LARGE), { fontWeight: [null, 'bold'] }),
    },
});
//# sourceMappingURL=help-overlay.js.map